Array.firstBy = function (fn) {
    let tb = function (y) {
        let x = this;
        let f = function (a, b) {
            return x(a, b) || y(a, b);
        };
        f.thenBy = tb;
        return f;
    };
    let fb = fn;
    fb.thenBy = tb;
    return fb;
};
Array.prototype.first = function () {
    return this.length > 0 ? this[0] : null;
};
Array.prototype.last = function () {
    return this.length > 0 ? this[this.length - 1] : null;
};
Array.prototype.sortBy = function (key, type, reverse) {
    return this.sort(function (a, b) {
        let x = a[key];
        let y = b[key];
        switch (type) {
            case "int":
                x = parseInt(x, 10);
                y = parseInt(y, 10);
                break;
            default:
                x = x.toLowerCase();
                y = y.toLowerCase();
                break;
        }
        return ((x > y) - (y > x)) * (!reverse ? 1 : -1);
    });
};
Array.prototype.any = function (fn) {
    for (var i = 0; i < this.length; i++) {
        if (fn(this[i], i))
            return true;
    }
    return false;
};
Array.prototype.each = function (fn) {
    for (var i = 0; i < this.length; i++) {
        if (fn(this[i], i) === false)
            break;
    }
};
Array.prototype.firstOrDefault = function (fn, defaultValue) {
    for (var i = 0; i < this.length; i++) {
        if (fn(this[i], i)) {
            return this[i];
        }
    }
    return defaultValue;
};
Array.prototype.where = function (fn) {
    var arr = [];
    for (var i = 0; i < this.length; i++) {
        if (fn(this[i], i)) {
            arr.push(this[i]);
        }
    }
    return arr;
};
Array.prototype.select = function (fn) {
    var arr = [];
    for (var i = 0; i < this.length; i++) {
        arr.push(fn(this[i], i));
    }
    return arr;
};
Array.prototype.remove = function (fn) {
    var arr = [];
    for (var i = 0; i < this.length; i++) {
        if (!fn(this[i], i))
            arr.push(this[i]);
    }
    return arr;
};
Array.prototype.take = function (n) {
    if (arguments.length === 0)
        throw "number is undefined";
    n = n > this.length ? this.length : n;
    var arr = [];
    for (var i = 0; i < n; i++) {
        arr.push(this[i]);
    }
    return arr;
};
Array.prototype.skip = function (n) {
    if (arguments.length === 0)
        throw "number is undefined";
    n = n > this.length ? this.length : n;
    var arr = [];
    for (let i = n; i < this.length; i++) {
        arr.push(this[i]);
    }
    return arr;
};
